import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { PostHogProvider } from "posthog-js/react";
import { PostHogConfig } from "posthog-js";
import * as Sentry from "@sentry/remix";

Sentry.init({
  dsn: "https://5a8da001b1ea1abb07f9b62cff0fbbf7@o4508345776537600.ingest.us.sentry.io/4508345777848320",
  tracesSampleRate: 1,
  environment: process.env.NODE_ENV,

  integrations: [
    Sentry.captureConsoleIntegration(),
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
  ],
});

const options: Partial<PostHogConfig> = {
  api_host: "https://us.i.posthog.com",
  capture_exceptions: true,
  person_profiles: "always", // or 'always' to create profiles for anonymous users as well
  loaded: (ph: any) => {
    if (window.location.hostname === "localhost") {
      ph.opt_out_capturing(); // opts a user out of event capture
      ph.set_config({ disable_session_recording: true });
    }
  },
};

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <PostHogProvider
        apiKey="phc_YlAxrAHhFOEmoAgYqVZeeVJ5Do9aEHHgv6vKXiE2ROC"
        options={options}
      >
        <RemixBrowser />
      </PostHogProvider>
    </StrictMode>
  );
});
